import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import EventItem from 'components/Events/EventItem';
import { EventItem as EventItemDataProps } from 'components/EventsCalendar/types';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import _ from 'lodash';
import EventFilter from 'components/Events/EventFilter';

interface EventItemProps {
  events: EventItemDataProps[];
  isAdmin: boolean;
}
const EventList = ({ events, isAdmin }: EventItemProps) => {
  const { t } = useTranslation(['organizations']);
  const [filteredEvents, setFilteredEvents] = useState(events);
  const router = useRouter();
  const { filter = 'upcoming' } = router.query;

  const containerClass = classNames(
    'flex flex-wrap -mx-2 gap-y-4 pl-10 pr-10',
    {
      'justify-around': events?.length > 1,
      'justify-between': events?.length <= 1
    }
  );

  // TODO
  // Apply filter from the API for org and association events
  // ticket link: https://bouncelife.atlassian.net/browse/BOUNCE-1739
  const filterEvents = (filterType) => {
    const today = new Date();
    let filtered;

    switch (filterType) {
      case 'upcoming':
        filtered = events?.filter(
          (event) => !event.isDraft && new Date(event.startDate) >= today
        );
        break;
      case 'draft':
        filtered = events?.filter((event) => event.isDraft);
        break;
      case 'past':
        filtered = events?.filter(
          (event) => !event.isDraft && new Date(event.startDate) < today
        );
        break;
      default:
        filtered = events;
    }
    const sortedEvents = _.sortBy(filtered, (event) =>
      new Date(event.startDate).getTime()
    );
    setFilteredEvents(sortedEvents);
  };

  useEffect(() => {
    filterEvents(filter);
  }, [filter, events, router.query]);

  if (!isAdmin && filter === 'draft') {
    router.replace({
      pathname: router.pathname,
      query: { ...router.query, filter: 'upcoming' }
    });

    return null;
  }

  return (
    <>
      <EventFilter isAdmin={isAdmin} />
      <div className={containerClass}>
        {filteredEvents?.length > 0 ? (
          filteredEvents.map((event) => (
            <EventItem
              key={event.id}
              title={event.title}
              imageUrl={event.photo.url}
              date={event.startDate}
              eventId={event.id}
            />
          ))
        ) : (
          <p className="text-sm">
            {t('events.noEventsScheduled', {
              filter: t(`events.filters.${filter}`)
            })}
          </p>
        )}
      </div>
    </>
  );
};

export default EventList;
